/**
 * Compute a stable, persistent device fingerprint that travels with every
 * API request. Web browsers cannot expose MAC address or IMEI (OS-level
 * privacy), so we substitute with a deterministic hash of the user-agent +
 * canvas/WebGL signal + a long-lived device cookie.
 *
 * The fingerprint is added as `x-device-fingerprint` header so the backend
 * can store it alongside IP on every security-relevant audit row.
 */

const STORAGE_KEY = "lawos_device_fp_v1";

function _hash(s) {
    let h = 0;
    for (let i = 0; i < s.length; i++) {
        h = ((h << 5) - h) + s.charCodeAt(i);
        h |= 0;
    }
    return Math.abs(h).toString(36);
}

function _canvasSignal() {
    try {
        const c = document.createElement("canvas");
        const ctx = c.getContext("2d");
        ctx.textBaseline = "top";
        ctx.font = "14px Arial";
        ctx.fillStyle = "#069";
        ctx.fillText("LawOS-FP-2026", 2, 2);
        ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
        ctx.fillText("LawOS-FP-2026", 4, 4);
        return _hash(c.toDataURL());
    } catch (e) {
        return "no-canvas";
    }
}

function _platformSignal() {
    return [
        navigator.userAgent,
        navigator.language,
        screen.width + "x" + screen.height,
        new Date().getTimezoneOffset(),
        navigator.hardwareConcurrency || "",
        navigator.platform,
    ].join("|");
}

export function getDeviceFingerprint() {
    try {
        const existing = localStorage.getItem(STORAGE_KEY);
        if (existing) return existing;
    } catch (_) { /* ignore */ }
    const fp = _hash(_canvasSignal() + "::" + _platformSignal());
    try { localStorage.setItem(STORAGE_KEY, fp); } catch (_) { /* ignore */ }
    return fp;
}

export function getDeviceMeta() {
    return {
        fingerprint: getDeviceFingerprint(),
        user_agent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        screen: screen.width + "x" + screen.height,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
}
